import React, {useState, useEffect} from "react";
import Navigation from "../MynextId/Navigation/Navigation";
import Footer from "../MynextId/Footer/Footer";
import homeBG from "../../../img/AboutUs/about-us-home.png";


function PrivacyPolicy() {
    useEffect(() => {
        require("../../../scss/myNextId.scss");
        if(!document.getElementById("usercentrics-ppg")) {
            console.log("adding usercentrics ppg")
            document.head.innerHTML += `<script
                id="usercentrics-ppg"
                privacy-policy-id="a4dd3f09-61ab-4a34-8941-de0c5ac39ce1"
                data-language="en"
                src="https://policygenerator.usercentrics.eu/api/privacy-policy"
            ></script>`
        }
    }, []);

    const [sidebarOpened, setSidebarOpened] = useState(false);

    return (
        <div className={sidebarOpened ? "main-theme overlay" : "main-theme"}>
            <Navigation
                sidebarOpened={() => setSidebarOpened(!sidebarOpened)}
            />

            <div className="about-us-section">
                <div className="home-text">
                    <h1 className="header">
                        <span className="">
                            <span className="home-text-underline">&nbsp;</span>

                            <span className="home-text-underline">
                                Privacy Policy
                            </span>
                            <span className="home-text-underline">&nbsp;</span>
                        </span>
                    </h1>
                </div>
                <div className="home-elements">
                    <img className="home-bg" src={homeBG} alt="home-bg" />
                </div>
            </div>

            <div className="uc-privacy-policy"></div>
            
            {/*<PrivacyPolicyText />*/}
            <Footer />
        </div>
    );
}

export default PrivacyPolicy;